import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import Placeholder from './Placeholder.jsx';
import styles from './SmallStat.module.css';
import clsx from "clsx";

function SmallStat({stat, secondStat = false, unit = false, icon, noData, diminishedStat = false}) {
  const {t} = useTranslation();
  return (
    <div className={styles.StatWrapper}>
      <div className={styles.StatBox}>
        {!noData && (
          <>
            <div className={styles.PrimaryStat}>
              <Placeholder ready={stat} xs={6} className={clsx(styles.StatPlaceholder, diminishedStat && styles.DimStatPlaceholder)}>
                <>
                  <span className={clsx(styles.Stat, diminishedStat && styles.DimStat)}>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {stat}
                  </span>
                  {unit !== false && <span className={styles.Unit}>&nbsp;{unit}</span>}
                </>
              </Placeholder>
            </div>
            <div className={clsx(styles.SecondStat, diminishedStat && styles.DimSecondStat)}>
              {secondStat !== false && (
                <Placeholder ready={stat && secondStat} xs={11}>
                  {secondStat}
                </Placeholder>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SmallStat
